export const AtgContactUs = {
    AtgContactUs: {
        title: 'ATG Customer Center',
        reason: 'Reason To Contact',
        from: 'From Email',
        formRequired: 'From Email is required',
        reasonPlaceholder: 'Select a reason',
        reasonRequired: 'Please select a reason',
        reasons: {
        unableToLogin: 'Unable To Log-In',
        accountLocked: 'User Account Locked',
        technicalIssue: 'Technical Issue With Specific Browser',
        customerService: 'Customer Service',
        other: 'Other',
        },
        emailId: 'Email',
        emailRequired: 'Email is required',
        emailInvalid: 'Please enter a valid email address',
        userCountry: 'User Country',
        selectCountry: 'Select Country',
        countryRequired: 'Please select a country',
        subject: 'Subject',
        subjectRequired: 'Subject is required',
        message: 'Message',
        messageRequired: 'Message is required',
        cancel: 'Cancel',
        email: 'Email',
        submitError: 'Something went wrong. Please try again.',
    }
}